const routes = [
  {
    path: '/photos',
    name: 'site-photos',
    meta: {
      authRequired: true,
      roles: []
    },
    component: () => import('./Index.vue')
  },
  {
    path: '/photos/new',
    name: 'site-photos-new',
    meta: {
      authRequired: true,
      roles: []
    },
    component: () => import('./Form.vue')
  },
  {
    path: '/photos/:id/edit',
    name: 'site-photos-edit',
    meta: {
      authRequired: true,
      roles: []
    },
    component: () => import('./Form.vue')
  }
]

export { routes }
export default routes
